import { Component, Prop, Watch } from 'vue-property-decorator';
import { GridOptions, ColDef, BodyScrollEvent, ColumnMovedEvent } from 'ag-grid-community';

import { loadingTemplate } from 'src/util/template';
import * as Vue from 'vue-tsx-support';
import 'vue-tsx-support/enable-check';
import Spin from '../../types/iview/Spin';
import { CellOperateItemProps } from '../agGridComponent/cellOperate';
import PageCustom, { PageCustomProps } from '../pageCustom/pageCustom';
import { AsyncCellRenderStatesI } from '../agGridComponent/asyncCellRender';
import { CellRenderTsxpStatesI } from '../agGridComponent/cellRenderTsx';
import { AddRemoveRenderStateI } from '../agGridComponent/addRemoveRender';
import { TextRenderRenderStateI } from '../agGridComponent/TextRender';
import { NumberRenderStateI } from '../agGridComponent/NumberRender';
import { DatePickerStateI } from '../agGridComponent/dateRender';
import { defaultRowHeight } from '../../config';
import './agGridVueCustomTsx.less';
import Bus, { Events } from '../../util/bus';
import { TreeRenderStateI } from '../agGridComponent/TreeSelectRender';
import { SelectRenderStateI } from '../agGridComponent/SelectRender';
import { BusSelectRenderStateI } from '../agGridComponent/busSelectRender';
import AgColService from './service/agColService';
import Draggable from 'vuedraggable';
import { CommonUtil } from 'src/util/commonUtil';

export type CellRendererFrameworkOpt =
    | Array<CellOperateItemProps>
    | AsyncCellRenderStatesI
    | CellRenderTsxpStatesI
    | AddRemoveRenderStateI
    | TextRenderRenderStateI
    | NumberRenderStateI
    | DatePickerStateI
    | TreeRenderStateI
    | SelectRenderStateI
    | BusSelectRenderStateI;
export type HeaderComponentFrameworkOpt = any;

export interface ColDefCustom extends ColDef {
    authority?: { [str: string]: boolean };
    cellRendererFrameworkOpt?: CellRendererFrameworkOpt;
    headerComponentFrameworkOpt?: HeaderComponentFrameworkOpt;
    children?: Array<ColDefCustom>;
}

export interface AgGridVueCustomTsxProps extends GridOptions, PageCustomProps {
    gridOptions: GridOptions;
    columnDefs: ColDefCustom[];
    unSortIcon?: boolean;
    serialNumberShow?: boolean; // 序号展示
    checkBoxShow?: boolean; // 多选框展示
    enableServerPage?: boolean; // 是否开启服务端排序
    pageShow?: boolean; // 分页是否展示
    needColControl?: boolean; // 分页是否展示
    cacheKey?: string; // 分页是否展示
    footerRender?: any;
}

export interface AgColControl {
    [field: string]: { rank: number; hide: boolean };
}

let uuid = 0
@Component({
    name: 'agGridVueCustom',
})
export default class AgGridVueCustomTsx extends Vue.Component<AgGridVueCustomTsxProps, {}> {
    constructor() {
        super();
    }

    @Prop({
        type: Object,
    })
    footerRender!: any;

    @Prop({
        type: Boolean,
        default: true,
    })
    unSortIcon!: boolean;

    @Prop({
        //	和服务端排序不能同时生效
        type: Boolean,
        default: false,
    })
    enableSorting!: boolean;

    @Prop({
        type: Boolean,
        default: true,
    })
    suppressMovableColumns!: boolean;

    @Prop({
        type: Object,
        default: () => {},
    })
    gridOptions!: GridOptions;

    @Prop({
        type: Array,
        default: function() {
            return [];
        },
    })
    columnDefs!: ColDefCustom[];

    @Prop({
        default: function() {
            return [];
        },
    })
    rowData!: Array<object>;

    @Prop({
        type: Boolean,
        default: true,
    })
    enableColResize!: boolean;

    @Prop({
        type: String,
        default: 'multiple',
    })
    rowSelection!: string;

    @Prop({
        type: Boolean,
        default: true,
    })
    suppressRowClickSelection!: boolean;

    @Prop({
        type: Boolean,
        default: true,
    })
    groupUseEntireRow!: boolean;

    @Prop({
        type: Number,
        default: defaultRowHeight,
    })
    rowHeight!: number;

    @Prop({
        type: Number,
        default: defaultRowHeight,
    })
    headerHeight!: number;

    @Prop({
        type: String,
        default: 'normal',
    })
    domLayout!: string;

    @Prop({
        default: loadingTemplate,
    })
    overlayLoadingTemplate!: string;

    @Prop({
        type: Boolean,
        default: true,
    })
    enableServerSideSorting!: boolean;

    @Prop({
        type: Function,
    })
    selectionChanged!: () => void;

    @Prop({
        type: Function,
    })
    rowSelected!: () => void;

    @Prop({
        type: Function,
    })
    sortChanged!: () => void;

    @Prop({
        type: Function,
    })
    rowClicked!: () => void;

    @Prop({
        type: Function,
    })
    columnMoved!: (event: ColumnMovedEvent) => void;

    @Prop({
        type: Function,
    })
    bodyScroll!: (e: BodyScrollEvent) => void;

    @Prop({
        type: Boolean,
        default: true,
    })
    @Prop({
        type: Object,
    })
    showClickColorCustom!: boolean;

    @Prop({
        type: Boolean,
        default: true,
    })
    serialNumberShow!: boolean;

    @Prop({
        type: Boolean,
        default: false,
    })
    checkBoxShow!: boolean;

    @Prop({
        type: Boolean,
        default: true,
    })
    pageShow!: boolean;

    @Prop({
        type: Boolean,
        default: true,
    })
    enableServerPage!: boolean;

    @Prop({
        type: Number,
        default: 0,
    })
    total!: number;

    @Prop({
        type: Number,
        default: 10,
    })
    pageSize!: number;

    @Prop({
        type: Array,
    })
    pageSizeOpts!: Array<number>;

    @Prop({
        type: Number,
    })
    current!: number;

    @Prop({
        type: Function,
        default: () => {},
    })
    pageSizeChanged!: (num: number) => void;

    @Prop({
        type: Function,
        default: () => {},
    })
    pageChanged!: (num: number) => void;

    @Prop({
        type: Boolean,
        default: false,
    })
    gridAutoHeight!: boolean;

    @Prop({
        type: Boolean,
        default: false,
    })
    needColControl!: boolean;

    @Prop({
        type: String,
        default: 'ag',
    })
    cacheKey!: string;

    loading: boolean = false;

    rowClassRules!: object;

    // 滚动条位置
    position: { top: number; left: number } = { top: 0, left: 0 };

    gridPromis!: Promise<GridOptions>;

    currentPage: number = 1;

    currntPageSize: number = 10;

    // 表格高度
    totalHeight: number = 0;

    // 列控制
    colControl: ColDefCustom[] = [];

    excludeFields = ['operate'];

    agColService!: AgColService;
    timeout!: any;
    // 是否在表格空白处化横线
    showline: boolean = true;

    domId: string = 'ag-'+ uuid++

    get rowRules() {
        if (!this.showClickColorCustom) {
            return this.rowClassRules;
        }
        return {
            ...(this.rowClassRules || {}),
            'wms-row-click': function(params) {
                return params.data.rowClicked === true;
            },
        };
    }

    get currentPageRowData(): Array<object> {
        if (!this.pageShow) {
            return this.rowData;
        }
        if (this.enableServerPage) {
            return [...this.rowData];
        } else {
            return this.rowData.slice(
                (this.currentPage - 1) * this.currntPageSize,
                (this.currentPage - 1) * this.currntPageSize + this.currntPageSize,
            );
        }
    }

    get totalCount(): number {
        // 服务端分页  总数量 通过外部 props 传入
        // 前端分页  总数量取 rowData.lengtH
        if (this.enableServerPage) {
            return this.total;
        } else {
            return this.rowData.length;
        }
    }

    get columnDefsCustom(): ColDefCustom[] {
        let columnDefsCustom: ColDefCustom[] = [];
        if (this.needColControl) {
            let pinned: any = { left: [], right: [] };
            this.columnDefs.forEach(i => {
                if (i.pinned) {
                    pinned[i.pinned as string].push(i);
                }
            });
            columnDefsCustom = [...pinned.left, ...this.colControl, ...pinned.right];
        } else {
            columnDefsCustom = this.columnDefs;
        }
        columnDefsCustom = columnDefsCustom.map(item => {
            // 权限控制
            if (item.field === 'operate' && CommonUtil.isArray(item.cellRendererFrameworkOpt)) {
                let opt = item.cellRendererFrameworkOpt as Array<CellOperateItemProps>;
                // let authority = this.$route.meta.authority;
                let operateShow = false;
                opt.map(o => {
                    // if (authority && authority[o.text] === false) {
                    //     o.hide = true;
                    // } else {
                    //     operateShow = true;
                    // }
                    operateShow = true;
                    return o;
                });
                if (operateShow === false) {
                    item.hide = true;
                }
                item.cellRendererFrameworkOpt = opt;
                return item;
            } else {
                return item;
            }
        });
        if (this.checkBoxShow) {
            columnDefsCustom.unshift(AgColService.createSelectionCol());
        }
        // 表格前序号
        if (this.serialNumberShow) {
            let serialNum = this.pageShow ? (this.getPage() - 1) * this.getPageSize() : 0;
            columnDefsCustom.unshift(AgColService.createSerialCol(serialNum));
        }

        return columnDefsCustom;
    }

    @Watch('rowData', {immediate: true})
    onRowData(val: string, oldVal: string) {
        // let totalHeight: number = 0;
        // this.rowData.forEach(item => {
        //   if (this.gridOptions.getRowHeight) {
        //     let params = {
        //       node: {
        //         data: item,
        //       },
        //     };
        //     totalHeight += this.gridOptions.getRowHeight(params);
        //   } else {
        //     totalHeight += this.rowHeight;
        //   }
        // });
        // this.totalHeight = totalHeight;
        // let api: any = this.gridOptions.api;
        // if (totalHeight > this.rowHeight * 10) {
        //   api.setGridAutoHeight(false);
        // } else {
        //   api.setGridAutoHeight(true);
        // }
        if (!this.enableServerPage) {
            this.currentPage = 1;
        }
        setTimeout(() => {
            this.setGirdLine();
        });
    }

    setGirdLine() {
        let isScrollbarVisible: boolean;
        let dom: any = document.querySelector(`#${this.domId} .ag-body-viewport`);
        // if (dom!.scrollHeight > dom!.clientHeight || dom!.offsetHeight > dom!.clientHeight + 2) {
        if (dom!.scrollHeight > dom!.clientHeight ) {
            isScrollbarVisible = true;
        } else {
            isScrollbarVisible = false;
        }
        this.showline = this.domLayout === 'normal' && !isScrollbarVisible;
    }

    @Watch('columnDefs')
    columnDefsChanged() {
        let t = this;
        if (this.needColControl) {
            t.colControl = t.agColService.getColsByCacheControl();
            t.agColService.setColCacheByNewCols();
        }
    }

    @Watch('columnDefsCustom')
    columnDefsCustomChanged() {
        let t = this;
        this.$nextTick(() => {
            t.sizeColumnsToFit();
        });
    }

    getPageSize(): number {
        // 服务端排序 分页相关数据从外部取
        if (this.enableServerPage) {
            return this.pageSize;
        } else {
            return this.currntPageSize;
        }
    }

    getPage(): number {
        // 服务端排序 分页相关数据从外部取
        if (this.enableServerPage) {
            return this.current;
        } else {
            return this.currentPage;
        }
    }

    bodyScrollHandler(e) {
        this.position = {
            top: e.top,
            left: e.left,
        };
        this.bodyScroll && this.bodyScroll(e);
    }

    columnMovedHandler(columnMovedType) {
        this.columnMoved && this.columnMoved(columnMovedType);
    }

    async sizeColumnsToFit() {
        let t = this;
        await this.gridPromis;
        let api: any = this.gridOptions.api;
        api.sizeColumnsToFit();

        this.$gridList.add(t.gridOptions);
    }

    async getApi(): Promise<any> {
        await this.gridPromis;
        let api: any = this.gridOptions.api;
        return api;
    }

    getSelectRows(): any[] {
        return (this.gridOptions.api as any).getSelectedRows() as any[];
    }

    beforeDestroy() {
        this.$gridList.delete(this.gridOptions);
        Bus.$off(Events.Resize);
    }

    created() {
        let t = this;
        this.agColService = new AgColService(this);

        if (this.needColControl) {
            t.colControl = t.agColService.getColsByCacheControl();
            t.agColService.setColCacheByNewCols();
        } else {
            t.colControl = [];
        }
        this.gridPromis = new Promise((resolve, reject) => {
            t.gridOptions.onGridReady = () => {
                resolve(t.gridOptions);
            };
        });
        Bus.$on('on-collapse', function() {
            t.sizeColumnsToFit();
        });
        let timeout
        Bus.$on(Events.Resize, () => {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
                this.setGirdLine()
            }, 200);
        });
    }

    async mounted() {
        let t = this;
        t.sizeColumnsToFit();
    }

    async activated() {
        let t = this;
        await t.sizeColumnsToFit();
        let api: any = this.gridOptions.api;
        api.gridPanel.setBodyViewportScrollLeft(this.position.left);
    }

    async showLoading() {
        this.loading = true;
    }

    getRowStyle(params) {
          if(params.data.site_status == 0){
            return {'background-color': 'red'}
          }
    }

    async hideLoading() {
        this.loading = false;
    }

    pageSizeChangedHandler(pageSize: number) {
        if (this.enableServerPage) {
            CommonUtil.isFunction(this.pageSizeChanged) && this.pageSizeChanged(pageSize);
        } else {
            this.currntPageSize = pageSize;
        }
    }

    pageChangedHandler(page: number) {
        if (this.enableServerPage) {
            CommonUtil.isFunction(this.pageChanged) && this.pageChanged(page);
        } else {
            this.currentPage = page;
        }
    }

    render(h) {
        return (
            <div class={this.rowHeight==130?"clearfix wqms-custom-table-big":"clearfix wqms-custom-table"} >
                <div style={{ position: 'relative', overflow: 'hidden' }} class="ag-theme-material wqms-table ">
                    {this.needColControl && (
                        <dropdown class="wqms-filter-wrapper" trigger="hover" transfer={true} ref="dropdown">
                            <div class="wqms-filter-icon-wrapper">
                                <span class="wqms-font icon-shaixuan" />
                            </div>
                            <dropdown-menu slot="list" class="wqms-col-control">
                                <Draggable
                                    options={{ animation: 150 }}
                                    v-model={this.colControl}
                                    on-change={this.agColService.setColCacheByNewCols.bind(this.agColService)}
                                >
                                    <transition-group>
                                        {this.colControl.map(i => {
                                            return (
                                                <div class="wqms-plr10" key={i.field}>
                                                    <checkbox
                                                        value={!i.hide}
                                                        on-input={this.agColService.colHideChange.bind(this.agColService, i)}
                                                    >
                                                        {i.headerName}
                                                    </checkbox>
                                                </div>
                                            );
                                        })}
                                    </transition-group>
                                </Draggable>
                            </dropdown-menu>
                        </dropdown>
                    )}
                    <div class="wqms-table-line" v-if={this.showline}>
                        {Array.from({ length: 20 }).map(i => <div />)}
                    </div>
                    <ag-grid-vue
                        style="height: 100%"
                        id={this.domId}
                        class={{
                            'wqms-no-data': this.rowData.length === 0,
                        }}
                        suppressNoRowsOverlay
                        suppressMovableColumns={this.suppressMovableColumns}
                        gridOptions={this.gridOptions}
                        columnDefs={this.columnDefsCustom}
                        rowData={this.currentPageRowData}
                        enableColResize={this.enableColResize}
                        rowSelection={this.rowSelection}
                        suppressRowClickSelection={this.suppressRowClickSelection}
                        groupUseEntireRow={this.groupUseEntireRow}
                        rowHeight={this.rowHeight}
                        headerHeight={this.headerHeight}
                        domLayout={this.domLayout}
                        overlayLoadingTemplate={this.overlayLoadingTemplate}
                        enableServerSideSorting={this.enableServerSideSorting}
                        enableSorting={this.enableSorting}
                        selectionChanged={this.selectionChanged}
                        rowSelected={this.rowSelected}
                        sortChanged={this.sortChanged}
                        rowClicked={this.rowClicked}
                        rowClassRules={this.rowRules}
                        unSortIcon={this.unSortIcon}
                        columnMoved={this.columnMovedHandler}
                        bodyScroll={this.bodyScrollHandler}
                        gridAutoHeight={this.gridAutoHeight}
                        autoSizePadding="10"
                    />
                    {this.footerRender && <div class="wqms-grid-footer">{this.footerRender}</div>}
                    <Spin size="large" fix v-show={this.loading} />
                </div>
                {this.pageShow && (
                    <div class="wqms-page-wrapper">
                        <PageCustom
                            current={this.getPage()}
                            pageSize={this.getPageSize()}
                            total={this.totalCount}
                            pageSizeOpts={this.pageSizeOpts}
                            showElevator={true}
                            showSizer={true}
                            showTotal={true}
                            pageSizeChanged={this.pageSizeChangedHandler}
                            pageChanged={this.pageChangedHandler}
                        />
                    </div>
                )}
            </div>
        );
    }
}
